const SOCIAL_URLS = [
  'https://www.youtube.com/channel/UC0kOOsZ55RofRas1uPIEZmg',
  'https://www.instagram.com/mightynetworks/',
  'https://www.facebook.com/mightynetworks/',
  'https://twitter.com/mightynetworks',
  'https://www.linkedin.com/company/mightynetworks/',
  'https://open.spotify.com/show/2TiP4Lihr9NMaZhGmviWY2',
];

export const buildOrganizationSchema = (imageUrl?: string): Record<string, unknown> => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Mighty Networks',
  alternateName: 'Mighty',
  url: 'https://www.mightynetworks.com',
  logo: 'https://www.mightynetworks.com/favicon.svg',
  ...(imageUrl && { image: imageUrl.startsWith('http') ? imageUrl : `https:${imageUrl}` }),
  sameAs: SOCIAL_URLS,
  founder: {
    '@type': 'Person',
    name: 'Gina Bianchini',
  },
});
